import React from 'react';
import { Link } from 'react-router-dom';

export default function LegalInformation() {
  return (
    <div className="max-w-4xl mx-auto px-6 py-12 text-gray-800">
      <Link to="/" className="text-cyan-500 underline mb-6 inline-block">← Back to Home</Link>
      <h1 className="text-3xl font-bold mb-4">Legal Information</h1>
      <p className="mb-4">
        V Adithya Pvt. Ltd. is a registered company in India. All content on this website is the intellectual property of the company and may not be copied or reproduced without permission.
      </p>
      <p className="mb-4">
        Unauthorized use of our logo, branding, or trademarks is strictly prohibited.
      </p>
      <p className="mb-4">
        For legal queries, email us at <a href="mailto:legal@adithyainfinity.com" className="text-cyan-500">legal@adithyainfinity.com</a>.
      </p>
    </div>
  );
}
